export default {
  projectDesc: '基于 <strong>Vue2</strong> 简洁、实用的分页栏',
  demo: {
    pageChangeLogs: '分页信息修改日志',
    gallery: '画廊内容实例',
    complete: '完整分页栏',
    noLength: '无分页尺寸选择栏',
    noPageInfo: '无分页信息栏',
    noFirstLast: '无首页，尾页按钮',
    noPageNumber: '无页码',
    border: '边框',
    displayAll: '显示所有数据模式',
    scopedSlots: '作用域插槽'
  },
  option: {
    vModel: '设置默认页/当前页',
    totalRow: '每次数据查询中的总记录数，在父组件进行数据查询后，必须更新插件的总记录数参数',
    info: '设置是否显示分页信息栏',
    language: '分页栏语言',
    pageSizeMenu: '分页尺寸列表, 可设置 <code>false</code> 来关闭该栏',
    align: '分页栏对齐方向',
    disabled: '启用/禁用 分页栏',
    border: '分页栏边框',
    pageNumber: '分页码',
    first: '首页按钮',
    last: '尾页按钮',
    displayAll: '在每页记录数列表中增加显示所有数据记录项目'
  },
  event: {
    pChange: '当分页数据变更时，插件触发的回调事件',
    pageNumber: '当前分页号',
    pageSize: '每页显示记录数'
  },
  api: {
    goPage: '切换当前页',
    reload: '更新分页信息及事件'
  }
}
